import { useStore } from 'react-redux';
import { SurveyLayer } from '../../constants/SurveyLayers';
import { Survey } from '../Prescription/PrescriptionJob';
import { formatDateAsYearMonthDateTime } from '../../helpers/DateUtils';

/**
 * The purpose of this hook is to hold the logic for correctly figuring out which survey
 * needs to be used to retrieve values for the given field and layer.
 */
export const useSurveyForField = () => {
  const store = useStore();

  const getSurveyForFieldAndLayer = (
    fieldId: number,
    layer: SurveyLayer,
    date?: Date | string,
    surveyImageId?: number | string
  ) => {
    const surveys = store.getState().survey.surveys;
    return (
      surveys &&
      surveys.find(
        (survey) =>
          survey.fieldId === fieldId &&
          survey.newImages?.[layer] &&
          (date ? surveyPublishedOnDate(survey, date) : true) &&
          (surveyImageId != null ? survey.surveyImageId === surveyImageId : true)
      )
    );
  };

  const surveyPublishedOnDate = (survey: Survey, date: Date | string) => {
    return formatDateAsYearMonthDateTime(survey.publishDate) === date;
  };

  return { getSurveyForFieldAndLayer };
};
